<template>
    <div id="company" class="tooltip">
        <v-row>
            <v-col :cols="2" class="text-right no-right no-bottom no-top middle-align pa-0 ma-0">Company:</v-col>
            <v-col :cols="8" class="text-left no-left no-bottom no-top pa-0 ma-0">
                <v-row>
                    <v-col :cols="10" class="text-right no-right no-bottom no-top middle-align pa-0 ma-0">
                        <v-text-field v-model="company" ref="company" placeholder="Type minimum 2 characters for search!"/>
                    </v-col>
            <v-col :cols="2" class="text-left no-left no-bottom no-top pa-0 ma-0">
                <v-progress-circular
                    :width="3"
                    :size="20"
                    color="primary"
                    indeterminate
                    v-if="showSpinner"
                    ></v-progress-circular>
            </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row>
            <v-col :cols="2" class="text-right no-right no-bottom no-top middle-align pa-0 ma-0"></v-col>
            <v-col :cols="8" class="text-left no-left no-bottom no-top pa-0 ma-0">
                <div id=companytooltip__tooltip>
                    <ul id="companytooltip__tooltip--list">
                        <li 
                        v-for="(a, i) in companyList" 
                        v-bind:key="i" 
                        v-ripple="{ class: `primary--text` }"
                        @click.prevent="choose(a)"
                        ><span v-if="isSelected(a)"> * </span>{{ a.companyName }}</li>
                    </ul>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col :cols="2" class="text-right no-right no-bottom no-top middle-align pa-0 ma-0"></v-col>
            <v-col :cols="8" class="text-left no-left no-bottom no-top pa-0 ma-0">
                <v-btn small color="primary" @click="close()">Close</v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
// import _ from 'lodash'
export default {
    name: 'AddCompanyTooltip',
    data: () => ({
        companyList: [],
        company: '',
        working: false,
        showSpinner:false,
        message: null,
        typing: null,
        debounce: null,
        states: [],
        companyStatesLocal: [],
    }),
    mounted() {
        this.$refs.company.focus()
        this.states = this.$store.getters["ProductData/getProductStates"];
    },
    methods: {
        close: function() {
            this.$emit('close', false)
        },
        choose: async function(o) {
            var view = this
            
            let co_states = o.co_states;
            co_states = co_states.trim().split(',');
            console.log('o.co_states.length', co_states);
            for(let j=0; j<co_states.length; j++){
              for(let i=0; i<view.states.length; i++){
                if(view.states[i].value.toString() === co_states[j].trim()){
                   await view.companyStatesLocal.push(view.states[i].text);
                }
              }
            }
            view.companyList = []
            if (view.isSelected(o)) {
                alert("You are selecting already selected company.")
            }
            else if(o.co_states.length > 0){
                view.$swal.fire({
                position: "bottom-end",
                icon: "warning",
                allowOutsideClick: false,
                title:
                `Warning: State Specific Company : ${view.companyStatesLocal}`,
                });
            }
            view.$emit('selectCompany', o)
        },
        isSelected: function(o) {
            var view = this,
                com = view.$store.getters['ProductData/getCompanies']
            return com.find(e => (e.companyID === o.companyID))
        },
        companySearch(o){
            var view = this
            view.companyList = []
            this.showSpinner = true
                view.$fetch({
                    url: view.$url('API') + 'data/company',
                    type: 'POST',
                    data: JSON.stringify({
                        get_company: o
                    }),
                    contentType: 'application/json'
                },{
                operation: 'add',
                vueScope: view
                }).then(function(r) {
                    view.showSpinner = false
                    if (parseInt(r.length) > parseInt(0)) {
                        view.companyList = []
                        r.forEach(function(o) {
                            view.companyList.push(o)
                        })
                    }
                }).catch(e => console.log(e),view.showSpinner = true)
        },
    },
    watch: {
        company: function(o) {
                var view = this
                if (o.length >= 2) {
                    let view = this
                    this.message = null
                    this.typing = 'You are typing'
                    clearTimeout(this.debounce)
                    this.debounce = setTimeout(() => {
                        this.typing = null
                        this.message = o
                        view.companySearch(this.message)
                    }, 600)
            }else{
                view.companyList = []
            }
        }
    },
}
</script>
<style lang="sass" scoped>
@import './../../assets/sass/product/addcompanytooltip'
.v-progress-circular
    top:25%
</style>